module.exports = __webpack_public_path__ + "static/media/cash_payment.e3ea1189.svg";